import { useTranslation } from 'common/hooks/useTranslation';

export const DownloadAuthenticatorApp = () => {
  const { t } = useTranslation('global');

  return (
    <div className="ms-32 flex flex-col gap-8">
      <p className="text-content-primary body-m">
        {t('profile.authenticationFactors.create.totp.openAppItemTitle')}
      </p>
      <p className="text-content-secondary-bg-primary body-s">
        {t('profile.authenticationFactors.create.totp.openAppItemDescription')}
      </p>
    </div>
  );
};
